import { render, staticRenderFns } from "./PageCreate.vue?vue&type=template&id=3cf919dc&"
import script from "./PageCreate.vue?vue&type=script&lang=js&"
export * from "./PageCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cf919dc')) {
      api.createRecord('3cf919dc', component.options)
    } else {
      api.reload('3cf919dc', component.options)
    }
    module.hot.accept("./PageCreate.vue?vue&type=template&id=3cf919dc&", function () {
      api.rerender('3cf919dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/page/PageCreate.vue"
export default component.exports